import styled from 'styled-components'

const LoadContainer = styled.p`
  margin: 0;
  padding: 0;

  color: ${p => p.theme.colors.$nightRider};
  font-size: ${p => p.theme.fonts.$p2};
  font-weight: ${p => p.theme.weights.$semiBold};
`
LoadContainer.displayName = 'LoadContainer'
export default LoadContainer
